import { Icon } from '@/new/components/icon';

interface MatterStatCardProps {
  icon: string;
  label: string;
  value: string | number;
}

export function MatterStatCard({ icon, label, value }: MatterStatCardProps) {
  return (
    <div className="rounded-md border border-l-4 border-gray-200 border-l-gray-200 bg-gradient-to-b from-gray-50 to-gray-100 px-3 py-2">
      <div className="flex items-center gap-2">
        <Icon className={`${icon} text-base text-gray-500`} />
        <p className="text-sm text-gray-500">{label}</p>
      </div>
      <p className="font-serif text-lg font-semibold text-gray-800">{value}</p>
    </div>
  );
}
